import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { userDetail } from "../../../store/actions/userActions";
import SurveyListHeader from "../../../component/layout/MainHeader";
import SurveyListSidebar from "../../../component/layout/MainSidebar";
import { Link, useNavigate } from "react-router-dom";
import Svg from "../../../component/Svg";
import SearchInput from "../../../core/Inputs/SearchInput";
import DataTable from "react-data-table-component";
import DuplicateRoi from "./DuplicateRoi";
import { toast } from "react-toastify";
import { formatDate } from "./FormatDate";
import { formatTime } from "./FormatTime";
import { performHttpRequest } from "../../../../axios/PerformHttpRequest";
import ExportExcel from "./ExportExcel";
import style from "../../../views/style.module.css";
import Card from "../../../core/Card";

export default function OnBoarding() {
  const { userData, userFlag } = useSelector((state) => state.userDataHeader);
  let permissions = {};
  if (userData && userData.length > 0) {
    try {
      permissions = JSON.parse(userData[0]?.module_permissions || "{}");
    } catch (error) {
      console.error("Error parsing module_permissions:", error);
    }
  }
  // Define permissions for the module
  const canAdd = permissions?.M1?.add === 1;
  const canEdit = permissions?.M1?.edit === 1;
  const canDelete = permissions?.M1?.del === 1;

  const apiUrl = process.env.REACT_APP_NODE_API_URL;
  const apiFrntUrl = process.env.REACT_APP_USER_LINK;
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const [onboardingData, setOnBoardingData] = useState([{}]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [roiId, setRoiId] = useState("");

  //State create for props
  const [roiName, setRoiName] = useState();
  useEffect(() => {
    onBoardingApiCall();
    getUserDetail();
  }, []);

  const getUserDetail = async () => {
    dispatch(userDetail());
  };

  const onBoardingApiCall = async () => {
    try {
      const response = await performHttpRequest(
        "GET",
        `${apiUrl}/roi/getRoiList`,
        ""
      );
      if (response?.data?.statusCode === 200) {
        setOnBoardingData(response?.data?.data);
      }
    } catch (error) {
      toast.error(error?.response?.data?.msg);
    }
  };

  const handleDuplicate = (row) => {
    setSelectedRow(row);
    setShowPopup(true); // Show the popup when edit button is clicked
  };

  const handleClosePopup = () => {
    setShowPopup(false); // Hide the popup
  };

  const handleEditTemplate = (row) => {
    navigate(`/admin/roi/${row.id}`);
  };

  const handleCustomVariables = (row) => {
    const props = {
      [row.name]: "/admin/roi",
      "Custom Variables": "",
    };
    navigate(`/admin/roi/${row.id}/custom-variable`, { state: props });
  };

  const handleCalculations = (row) => {
    const props = {
      [row.name]: "/admin/roi",
      "Calculation & Logic": "",
    };
    navigate(`/admin/roi/${row.id}/calculation-logic`, { state: props });
  };

  const handleCopy = (link) => {
    navigator?.clipboard
      ? navigator?.clipboard.writeText(link)
      : unsecuredCopyToClipboard(link);
    toast.success("Link copied to clipboard");
  };

  const unsecuredCopyToClipboard = (text) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      document.execCommand("copy");
    } catch (err) {
      console.error("Unable to copy to clipboard", err);
    }
    document.body.removeChild(textArea);
  };

  const handlePublish = async (row) => {
    try {
      const response = await performHttpRequest(
        "PATCH",
        `${apiUrl}/roi/update/${row?.id}`,
        { status: "publish" }
      );
      //console.log("roiId data ", response);
      if (response.data?.statusCode === 200) {
        toast.success(response?.data?.msg);
        onBoardingApiCall();
      }
    } catch (error) {
      toast.error(error?.response?.data?.msg);
    }
  };

  const data = onboardingData.map((item) => ({
    id: item.roi_id,
    name: item.roi_name,
    status: item?.status,
    add_date_time: `${item.add_date_time}/${item.added_by}`,
    added_by: item.added_by, // Include the added_by property for Reports Generated
    published: item.add_date_time,
    countries: item.country_name, // Include the countries array for Countries
    defaultlanguage: item?.default_language,
    primary_currency: item?.primary_currency,
    additionalCurrency: item?.additional_currency,
    created_by: item?.name,
  }));

  const columns = [
    {
      width: "300px",
      name: "Calculator name",
      sortable: true,
      sortField: "name",
      selector: (row) => row.name,
      cell: (row) => {
        const addDateTime = row?.published || ""; // Get the published field from the row
        return (
          <>
            <div className="w-100">
              {/* <span className="surv-title"  onClick={() => handleEditTemplate(row)}>{row.name}</span> */}
              {canEdit ? (
                <span
                  className="surv-title"
                  onClick={() => handleEditTemplate(row)}
                >
                  {row.name}
                </span>
              ) : (
                <span className="surv-title">{row.name}</span>
              )}
              <div className="modified-text">
                Modified {formatTime(addDateTime)} | Published on{" "}
                {formatDate(addDateTime)}
              </div>
            </div>
          </>
        );
      },
    },
    {
      name: "Share",
      cell: (row) => (
        <>
          <div className="text-center w-100 response-complete">
            <a
              href="#"
              className="copy-link"
              title="Copy link"
              onClick={() => {
                handleCopy(`${apiFrntUrl}/roi/${row?.id}`);
              }}
            >
              <Svg name="share" />
            </a>
          </div>
        </>
      ),
    },

    {
      name: "Reports generated",
      selector: "added_by",
      width: "200px",
      sortable: true,
      sortField: "added_by",
      cell: (row) => {
        return (
          <>
            <div className="text-center w-100">
              <span className="reports-text">{"0"}</span>
            </div>
          </>
        );
      },
    },

    {
      name: "Created by",
      selector: "added_by",
      sortable: true,
      sortField: "added_by",
      cell: (row) => {
        return (
          <>
            <div className="text-center w-100">
              <span className="created-text">{row?.created_by}</span>
            </div>
          </>
        );
      },
    },

    {
      name: "Countries",
      width: "180px",
      selector: "countries",
      sortable: true,
      sortField: "countries",
      cell: (row) => {
        let countriesData = row?.countries || [];
        if (typeof countriesData === "string") {
          try {
            countriesData = JSON.parse(countriesData);
          } catch (error) {
            toast.error(error);
          }
        }

        return (
          <div className="text-center w-100">
            <ul className="countires">
              {countriesData?.map((countryString, index) => {
                const countryName = countryString.replace(/"/g, ""); // Remove double quotes
                return <li key={index}>{countryName}</li>;
              })}
            </ul>
          </div>
        );
      },
    },

    {
      name: "Status",
      selector: "status",
      sortable: true,
      sortField: "status",
      cell: (row) => {
        return (
          <>
            <div className="text-center w-100">
              <span class={`table-status ${row.status}`}>{row.status}</span>
            </div>
          </>
        );
      },
    },
    {
      name: "Languages",
      width: "120px",
      sortable: false,
      cell: (row) => {
        return (
          <>
            <div className="text-center w-100">
              <span className="laguage-text">{row.defaultlanguage}</span>
            </div>
          </>
        );
      },
    },

    {
      name: "",
      width: "46px",
      cell: (row) => (
        <>
          {canEdit && (
            <div className="dropdown table-dropdown">
              <button
                className="btn dropdown-tgl"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <Svg name="action" />
              </button>
              <ul className="dropdown-menu dropdown-menu-end">
                {row?.status !== "publish" && (
                  <li>
                    <button
                      className="dropdown-item d-flex align-items-center"
                      type="button"
                      onClick={() => handleEditTemplate(row)}
                    >
                      <Svg name="dropdown-edit" />
                      <span className="dropdown-item ms-2">Edit</span>
                    </button>
                  </li>
                )}
                {canEdit && (
                  <li>
                    <button
                      className="dropdown-item d-flex align-items-center"
                      type="button"
                      onClick={() => handleCalculations(row)}
                    >
                      <Svg name="dropdown-calculcation" />
                      <span className="dropdown-item ms-2">
                        Calculations & Logics
                      </span>
                    </button>
                  </li>
                )}
                {canEdit && (
                  <li>
                    <button
                      className="dropdown-item d-flex align-items-center"
                      type="button"
                      onClick={() => handleCustomVariables(row)}
                    >
                      <Svg name="custom-variable" />
                      <span className="dropdown-item ms-2">
                        Custom Variables
                      </span>
                    </button>
                  </li>
                )}
                {canEdit && (
                  <li>
                    <button
                      className="dropdown-item d-flex align-items-center"
                      type="button"
                      onClick={() => handlePublish(row)}
                    >
                      <Svg name="dropdown-publish" />
                      <span className="dropdown-item ms-2">Publish</span>
                    </button>
                  </li>
                )}

                {canEdit && (
                  <li>
                    <button
                      className="dropdown-item d-flex align-items-center"
                      onClick={() => handleDuplicate(row)}
                      type="button"
                    >
                      <Svg name="dropdown-duplicate" />
                      <span className="dropdown-item ms-2">Duplicate</span>
                    </button>
                  </li>
                )}
                {canDelete && (
                  <li>
                    <button
                      className="dropdown-item d-flex align-items-center"
                      data-bs-toggle="modal"
                      data-bs-target="#deletepage"
                      onClick={() => handleDeleteRoi(row)}
                      type="button"
                    >
                      <Svg name="dropdown-delete" />
                      <span className="dropdown-item ms-2">Delete</span>
                    </button>
                  </li>
                )}
                {/* {canEdit && (
              <li>
                <button
                  className="dropdown-item d-flex align-items-center"
                  type="button"
                >
                  <Svg name="dropdown-archieve" />
                  <span className="dropdown-item ms-2">Move to Archive</span>
                </button>
              </li>
               )} */}
              </ul>
            </div>
          )}
        </>
      ),
    },
  ];

  const handleSearch = (e) => {
    const searchValue = e;
    setSearchQuery(searchValue);
  };

  const handleSearchIconClick = (inputValue) => {
    setSearchQuery(inputValue);
  };

  const handleClear = () => {
    setSearchQuery("");
  };

  const filteredData = data.filter(
    (item) =>
      typeof item.name === "string" &&
      item.name.toLowerCase().includes(searchQuery?.toLowerCase())
  );

  const handleSelectedRowsChange = (rows) => {
    setSelectedRows(rows.selectedRows);
  };

  const conditionalRowStyles = [
    {
      when: (row) => selectedRows.some((r) => r.id === row.id),
      style: {
        backgroundColor: "#F5F5F5",
      },
    },
  ];

  const handleDeleteRoi = (row) => {
    setRoiId(row?.id);
    //console.log(row, "row");
  };

  const confirmDeleteButton = async () => {
    try {
      const response = await performHttpRequest(
        "DELETE",
        `${apiUrl}/roi/delRoi/${roiId}`,
        ""
      );
      //console.log("roiId data ", response);
      if (response.data?.statusCode === 200) {
        toast.success(response?.data?.msg);
        onBoardingApiCall();
      }
    } catch (error) {
      toast.error(error?.response?.data?.msg);
    }
  };

  return (
    <>
      <div className="d-flex flex-column main-outer-wrapper main-site-wrapper">
        <SurveyListHeader />
        <div id="viewport" className="d-flex">
          <SurveyListSidebar />
          <div className="flex-grow-1 d-flex">
            <div className="dashboard-page-outer flex-grow-1">
              <div className="custom-breadcrumb">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link
                        to="/admin/roi"
                        className="home-item"
                        title="Calculator"
                      >
                        Home
                      </Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      <strong>Calculator</strong>
                    </li>
                  </ol>
                </nav>
              </div>
              <div className="dashboard-page-wrap">
                <div className="table-wrapper-view">
                  <div className="search-filter d-md-flex align-items-center surveyfilter">
                    <div className="flex-grow-1 pe-0 pe-md-3 mb-3 mb-md-0">
                      <SearchInput
                        className="custom-search-input"
                        type="def"
                        view="outlined"
                        color="primary"
                        placeholder="Search"
                        onSearch={handleSearch}
                        onClear={handleClear}
                        onSearchIconClick={handleSearchIconClick}
                        fill={true}
                      />
                    </div>

                    <ExportExcel selectedRows={selectedRows} />
                    {canEdit && (
                      <Link
                        to="/admin/roi/create"
                        className="btn btn-primary add-btn ms-md-2 mt-2 mt-md-0"
                      >
                        <Svg name="plus" /> Create
                      </Link>
                    )}
                  </div>
                  <div className="tablePage bg-white overflow-custom">
                    <div className="content-table survey-table survey-table-height">
                      <div className="data-table-wrap custom-data-table first-check">
                        <DataTable
                          columns={columns}
                          data={filteredData}
                          selectableRows={true}
                          onSelectedRowsChange={handleSelectedRowsChange}
                          pagination
                          onRowSelected={(state) =>
                            handleSelectedRowsChange(state)
                          }
                          selectableRowChecked={(row) =>
                            row.id === selectedRows[0]?.id
                          }
                          conditionalRowStyles={conditionalRowStyles}
                        />
                      </div>
                    </div>
                  </div>
                  {showPopup && selectedRow && (
                    <DuplicateRoi
                      rowData={selectedRow}
                      onClose={handleClosePopup}
                    />
                  )}{" "}
                </div>
              </div>
            </div>
          </div>
          <div
            className="customvar-modal modal custom-modal fade deleteModal"
            id="deletepage"
            tabIndex={-1}
            aria-labelledby="deleteModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-body">
                  <div className={"formcontainer " + style.container}>
                    <div
                      className={
                        "formvawrapper delete-modal-wrap modal-sm " +
                        style.wrapper
                      }
                    >
                      <Card
                        view="raised"
                        className={"formstyle p-0 " + style.card}
                      >
                        <div className="delete-body-wrap delete-language">
                          <div className="heading">
                            <h3>Delete ROI</h3>
                            <p>
                              Are you sure you want to delete ROI and its
                              associated values ?
                            </p>
                          </div>

                          <div className="button-wrap d-flex justify-content-end">
                            <button
                              type="button"
                              className="btn btn-bordered color-cancel"
                              data-bs-dismiss="modal"
                            >
                              Cancel
                            </button>
                            <button
                              type="button"
                              className="btn btn-primary ms-3"
                              onClick={confirmDeleteButton}
                              data-bs-dismiss="modal"
                            >
                              Confirm delete
                            </button>
                          </div>
                        </div>
                      </Card>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
